import { render, staticRenderFns } from "./PaginaAdminInstituciones.vue?vue&type=template&id=aceb7ec6"
import script from "./PaginaAdminInstituciones.vue?vue&type=script&lang=js"
export * from "./PaginaAdminInstituciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports